/* =============================================================
   cdn-club-livelli.js — i sigilli e la tabella dei livelli (snippets/cdn-club-livelli.liquid).
   Come nella foto di Stefano: si vedono TRE sigilli alla volta — quello scelto davanti e i due che vengono
   dopo dietro, mezzi coperti — sempre nell'ordine bianco, blu, rosso, nero, oro. Con le frecce escono gli altri
   (la finestra di tre scorre, senza giri in tondo: la prima è il Naso Bianco, l'ultima il Naso d'Oro).
   Si sceglie anche cliccando un sigillo di lato o l'intestazione di una colonna. Si apre sul Naso Bianco
   (l'iscritto sul suo livello). Sotto i 750 px la tabella mostra solo la colonna del livello scelto.
   ============================================================= */
(function () {
  var root = document.querySelector('[data-lvt]');
  if (!root) return;
  var sigilli = Array.prototype.slice.call(root.querySelectorAll('.lvt__sig'));
  var frecce = Array.prototype.slice.call(root.querySelectorAll('[data-lvt-va]'));
  var n = sigilli.length;
  if (!n) return;
  var QUANTI = Math.min(3, n); // quanti se ne vedono insieme
  var i = Number(root.getAttribute('data-attivo')) || 0;

  function mostra() {
    // la finestra di tre parte dal livello scelto e si ferma in fondo all'elenco
    var da = Math.min(i, n - QUANTI);
    if (da < 0) da = 0;
    sigilli.forEach(function (s, k) {
      var dentro = k >= da && k < da + QUANTI;
      s.hidden = !dentro;
      s.classList.toggle('is-on', k === i);
      s.setAttribute('aria-current', k === i ? 'true' : 'false');
      // il scelto davanti a tutti; gli altri in ordine, il primo sopra il secondo
      s.style.zIndex = k === i ? '20' : String(10 - (k - da));
    });
    frecce.forEach(function (f) {
      var va = Number(f.getAttribute('data-lvt-va'));
      f.disabled = (va < 0 && i === 0) || (va > 0 && i === n - 1);
    });
    root.setAttribute('data-attivo', String(i));
  }
  function vai(k) {
    if (k < 0) k = 0;              // niente giro in tondo: il primo è il Naso Bianco, l'ultimo il Naso d'Oro
    if (k > n - 1) k = n - 1;
    if (k === i) return;
    i = k;
    mostra();
  }

  root.addEventListener('click', function (e) {
    var fre = e.target.closest('[data-lvt-va]');
    if (fre) { vai(i + Number(fre.getAttribute('data-lvt-va'))); return; }
    var scelto = e.target.closest('.lvt__sig, [data-lvt-col]');
    if (scelto) vai(Number(scelto.getAttribute('data-i')));
  });
  root.addEventListener('keydown', function (e) {
    if (!e.target.closest('.lvt__sig, [data-lvt-va]')) return;
    if (e.key === 'ArrowRight') { vai(i + 1); e.preventDefault(); }
    if (e.key === 'ArrowLeft') { vai(i - 1); e.preventDefault(); }
  });

  mostra();
})();
